<section
  class="popular-brands"
  *ngIf="!loading && brands.length > 0"
>

  <div class="brands-head">

    <h2>
      {{ title || t('popularBrandsNav') }}
    </h2>

    <button
      type="button"
      class="see-all"
      *ngIf="canToggle"
      (click)="toggle()"
    >
      {{
        expanded
          ? (bn ? 'কম দেখুন' : 'Show less')
          : (bn ? 'সব দেখুন' : 'See all')
      }}
      <span aria-hidden="true">{{ expanded ? '«' : '»' }}</span>
    </button>

  </div>


  <div class="brands-grid">

    <article
      class="brand-card"
      *ngFor="let brand of visible; trackBy: trackByBrand"
      [title]="brand.name"
    >

      <img
        *ngIf="showImage(brand)"
        [src]="brand.imageUrl"
        [alt]="brand.name"
        loading="lazy"
        decoding="async"
        (error)="onImageError(brand)"
      >

      <span
        *ngIf="!showImage(brand)"
        class="brand-name"
      >
        {{ brand.name }}
      </span>

    </article>

  </div>

</section>
